import React from 'react';
import './Styles.css';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { useNavigate } from 'react-router-dom';
import { teamPageReducerTypes } from '../../Reducer';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import SecondaryButton from '../../../../Elements/ids/Buttons/SecondaryButton';
import PrimaryButton from '../../../../Elements/ids/Buttons/PrimaryButton';
import { useTeamPageContext } from '../../TeamPage';

const LinkError = ({ errorMessage, codePrefix }) => {
  const { teamPageDispatch } = useTeamPageContext();
  const navigate = useNavigate();

  return (
    <div className="teamPage-linkError-container">
      <ErrorMessage message={errorMessage} />
      <div>{formatMessage(Messages.teamPage_linkError_description)}</div>
      <div className="teamPage-linkError-buttons">
        <SecondaryButton
          text={formatMessage(Messages.common_goToSearch)}
          onClickEvent={() => {
            navigate('/');
          }}
        />
        <PrimaryButton
          text={formatMessage(Messages.teamPage_linkError_goToTeamPage)}
          onClickEvent={() => {
            teamPageDispatch({
              type: teamPageReducerTypes.deepLinkErrorPage,
            });
            navigate(`/team/view/${codePrefix}`, { replace: true });
          }}
        />
      </div>
    </div>
  );
};

export default LinkError;
